import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import "../../assets/styles/local/SubscriptionInvoices.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const SubscriptionInvoices = () => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("My-Plan").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  let teamListData = [
    {
      id: "1",
      name: "Ankit",
      img: "https://lighthouse-spire.s3.eu-west-2.amazonaws.com/Ankit Singh.jpg",
    },

    {
      id: "2",
      name: "Singh",
      img: "https://lighthouse-spire.s3.eu-west-2.amazonaws.com/ASC2.jpg",
    },
    {
      id: "3",
      name: "Chandel",
      img: "https://lighthouse-spire.s3.eu-west-2.amazonaws.com/ASC22.jpg",
    },
    {
      id: "4",
      name: "Ashu",
      img: "https://lighthouse-spire.s3.eu-west-2.amazonaws.com/ASC22.jpg",
    },
  ];

  return (
    <div className="p-">
      <div className="ascTableWrapper pt-3 px-4" id="ascSelectBox">
        <table className="table">
          <thead>
            <tr className="tableHeading">
              <th className="txtField">
                {/* Invoice Nr. */}
                {t("Invoice Nr.")}
              </th>
              <th className="txtField" style={{ width: "10%" }}>
                {/* Created On */} 
                {t("Created On")}
              </th>
              <th className="txtField">
                {/* Description */}
                {t("Description")}
              </th>
              <th className="txtField">
                {/* Due Date */}
                {t("Due Date")}
              </th>
              <th className="txtField">
                {/* Amount */}
                {t("Amount ")}
              </th>
              <th className="txtField" style={{ width: "2-0%" }}>
                {/* Status */}
                {t("Status")}
              </th>
              <th className="txtField">
                {/* Transaction Date */}
                {t("Transaction date")}
              </th>
            </tr>
          </thead>

          <tbody className="tabLine   d-none">
            {teamListData?.map((item, index) => {
              return (
                <tr className="trHover animate__animated animate__bounceInLeft">
                  <td>{"Dummy Data"}</td>
                  <td>{moment(item.creationDate).format("DD.MM.YYYY")}</td>
                  <td>{"Dummy Data"}</td>
                  <td>{"Dummy Data"}</td>
                  <td>{"€ Dummy Data"}</td>
                  <td>{"Dummy Data"}</td>
                  <td>{"Dummy Data"}</td>

                  {/* <td style={{ width: "50px" }}>"asc"</td> */}

                  {/* <td style={{ width: "50px" }}>"asc"</td> */}

                  {/* <td style={{ width: "50px" }}>"asc"</td> */}
                </tr>
              );
            })}
            {/* Display a message when no projects are found */}

            {/* Display a message when no data to display */}
            {teamListData.length === 0 && (
              <span className="noDataDisplay">No data to display!</span>
            )}
          </tbody>

          {/* <tbody className="tabLine">
              <tr>
                <td>Ankit</td>
              </tr>
              <tr>
                <td>Singh</td>
              </tr>
              <tr>
                <td>Chandel</td>
              </tr>
            </tbody> */}
        </table>
      </div>
    </div>
  );
};

export default SubscriptionInvoices;
